import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from "./assets/i18n/en.json";
import translationTR from "./assets/i18n/tr.json";



// avaiable : [en,tr]

const getDefaultLanguage = localStorage.getItem("lang") || navigator.language || navigator.userLanguage || 'en'
// TODO !!!
// console.log("getDefaultLanguage",getDefaultLanguage)

// if (getDefaultLanguage === "tr") {
//     import('moment/locale/tr')
// }
// else {
//     import('moment/locale/en-au')
// }

// The interface language, once resolved ('de-DE' falls back to 'en'), goes
// onto <html lang>, which CSS uppercasing reads (Turkish needs İ, not I) and
// screen readers use. It is also kept in a `lang` cookie so the server can
// render a profile's first paint in the language React will switch to
// (pickLang in src/profileView.js); localStorage never reaches the server.
const syncLanguage = () => {
    const lang = (i18n.resolvedLanguage || i18n.language || '').slice(0, 2) === 'tr' ? 'tr' : 'en';
    document.documentElement.lang = lang;
    document.cookie = `lang=${lang}; path=/; max-age=31536000; SameSite=Lax`;
};
i18n.on('languageChanged', syncLanguage);

i18n
    .use(initReactI18next)
    .init({
        resources:{
            en: {
                translation: translationEN
            },
            tr: {
                translation: translationTR
            }
        },
        supportedLngs: ['tr', 'en'],
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        debug: false,
        lng: getDefaultLanguage,
        detection: {
            order: ["cookie", "localStorage", "htmlTag", "path", "subdomain"],
            caches: ["cookie"],
        }
    })

export default i18n

